import { Injectable } from '@angular/core';
import { AppRuntimeConfig } from './app-runtime-config.model';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private config: AppRuntimeConfig | null = null;

  setConfig(config: AppRuntimeConfig): void {
    this.config = config;
  }

  getConfig(): AppRuntimeConfig {
    if (!this.config) {
      throw new Error('Runtime config not loaded');
    }
    return this.config;
  }

  tryGetConfig(): AppRuntimeConfig | null {
    return this.config;
  }
}
